import RateLimitedAction from './helpers/rateLimitedAction';

const debounce: RateLimitedAction = (func) => {
    const debounced = function (this: unknown, ...args: Parameters<typeof func>) {
        return func.apply(this, args) as typeof func;
    };

    /* eslint-disable-next-line @typescript-eslint/no-empty-function*/
    debounced.cancel = () => {};

    return debounced;
};

export default debounce;
